import { defineComponent as _defineComponent } from 'vue'
import { customersService } from '@/services/tenants.service';
import { Customer } from '@/models/tenant';
import { UserType } from '@/models/userType';
import { hasCurrentUserPermission } from '@/utils/permissionUtils';
import { usersService } from '@/services/users.service';
import { computed, reactive, ref } from 'vue';
import { toastService } from '@/library-services/toast.service';
import useVuelidate from '@vuelidate/core';
import { useI18n } from '@/composables/i18n';
import CustomerForm from '@/components/customers/CustomerForm.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerProperties',
  props: {
    customer: null
  },
  emits: ["update"],
  setup(__props: any, { emit }: { emit: ((e: 'update', value: Customer) => void), expose: any, slots: any, attrs: any }) {

const props = __props as {
  customer: Customer;
};





const { t } = useI18n();

const isSubmitting = ref(false);

const editCustomer = reactive(Customer.GetCopy(props.customer));

const v$ = useVuelidate();

async function onSubmit() {
  isSubmitting.value = true;
  customersService
    .update(editCustomer)
    .then(async () => {
      toastService.success('tenant.update_success');
      emit('update', editCustomer);
      await usersService.me();
    })
    .finally(() => {
      isSubmitting.value = false;
    });
}

function cancel() {
  Object.assign(editCustomer, Customer.GetCopy(props.customer));
}

const canEditCustomer = computed(() =>
  hasCurrentUserPermission(UserType.SubsidiaryAdmin),
);

return { __sfc: true,props, emit, t, isSubmitting, editCustomer, v$, onSubmit, cancel, canEditCustomer, CustomerForm }
}

})